export default "__VITE_ASSET__a35e8c21__"